// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Library resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class LibraryClient {
  constructor(private readonly http: HttpClient) {}

  /** Search Connectors via the Inferrex API. */
  async searchConnectors(options?: { q?: string | undefined; category?: string | undefined; limit?: number | undefined }): Promise<{ connectors: Record<string, unknown>; query: string; category: string | null }> {
    return this.http.get<{ connectors: Record<string, unknown>; query: string; category: string | null }>('/v1/library/connectors', options);
  }

  /** Get Connector Manifest via the Inferrex API. */
  async getConnectorManifest(providerKey: string): Promise<{ manifest: Record<string, unknown> }> {
    return this.http.get<{ manifest: Record<string, unknown> }>(`/v1/library/connectors/${providerKey}`);
  }

  /** List Categories via the Inferrex API. */
  async listCategories(): Promise<{ categories: Record<string, unknown> }> {
    return this.http.get<{ categories: Record<string, unknown> }>('/v1/library/categories');
  }

  /** Submit Connector Contribution via the Inferrex API. */
  async submitConnectorContribution(request: { providerKey?: string; displayName?: string; category?: string; documentationUrl?: string; manifest?: Record<string, unknown>; notes?: string; contributorName?: string; contributorEmail?: string }, requestOptions?: RequestOptions): Promise<{ success: boolean; contributionId: string; status: string; message: string }> {
    return this.http.post<{ success: boolean; contributionId: string; status: string; message: string }>('/v1/library/contributions', request, requestOptions);
  }

  /** Get Contribution Status via the Inferrex API. */
  async getContributionStatus(id: string): Promise<{ id: string; providerKey: string; status: string; reviewNotes: string | null; releaseVersion: string | null; stagedAt: string; reviewedAt: string | null }> {
    return this.http.get<{ id: string; providerKey: string; status: string; reviewNotes: string | null; releaseVersion: string | null; stagedAt: string; reviewedAt: string | null }>(`/v1/library/contributions/${id}`);
  }

  /** Upload an API schema file to auto-generate a custom provider manifest. */
  async upload(request: { content: string; fileName: string; schemaTitle?: string; connectionId?: string }, requestOptions?: RequestOptions): Promise<{ success: boolean; manifestId: string; providerKey: string; detectedFormat: string; fieldsRequiringReview: string[]; error: { reason: string; statusCode?: number; currentCount?: number; limit?: number; upgradeUrl?: string; formatsAttempted?: string[] } }> {
    return this.http.post<{ success: boolean; manifestId: string; providerKey: string; detectedFormat: string; fieldsRequiringReview: string[]; error: { reason: string; statusCode?: number; currentCount?: number; limit?: number; upgradeUrl?: string; formatsAttempted?: string[] } }>('/v1/library/connectors/upload', request, requestOptions);
  }
}
